import LoginResource from "./login.resource";

const loginModule = angular
  .module("app.resources.login", [])
  .service("Login", LoginResource);

export default loginModule;



// WEBPACK FOOTER //
// ./src/resources/login/login.module.js